<a
  betterRouterLink="#main"
  tabindex="-1"
  class="mobi-ui-ink-default skip-to-main-content-link"
  id="skip-link"
>
  {{ 'skip_to_main_content' | texts: { context: 'frontend', default: 'Zum Inhalt' } }}
</a>

<div
  class="content"
  role="main"
  [class.no-animations]="!interactive()"
  [class.no-container]="hideHeader() || hideFooter()"
  [class.no-breadcrumb]="hideBreadcrumb()"
>
  @defer (hydrate on idle) {
    @if (!hideHeader()) {
      @if (platformService.isProtekta()) {
        <protekta-header />
      } @else {
        <mobi-header />
      }
    }
  }
  @defer (on idle; hydrate on idle) {
    <mobi-sitewide-alerts />
  }
  <div
    #content
    id="main"
    class="overflow-x-clip push !justify-start !outline-none"
    tabindex="-1"
  >
    <mobi-resolver />
    <router-outlet />
  </div>
  @defer (on idle) {
    <mobi-admin />
  }
  @defer (on idle; hydrate on idle) {
    @if (!hideFooter() && !navigating()) {
      @if (platformService.isProtekta()) {
        <protekta-footer />
      } @else {
        <mobi-footer />
      }
    }
  }
</div>
